var AttestationIdentityKeyInfo_1;
import { __decorate } from "tslib";
import { AsnType, AsnTypeTypes, AsnPropTypes, AsnArray } from "@peculiar/asn1-schema";
export const id_enrollAKIInfo = "1.3.6.1.4.1.311.21.39";
let AttestationIdentityKeyInfo = AttestationIdentityKeyInfo_1 = class AttestationIdentityKeyInfo extends AsnArray {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, AttestationIdentityKeyInfo_1.prototype);
    }
};
AttestationIdentityKeyInfo = AttestationIdentityKeyInfo_1 = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence, itemType: AsnPropTypes.Any })
], AttestationIdentityKeyInfo);
export { AttestationIdentityKeyInfo };
